import { Box, Typography } from "@mui/material";
import React from "react";
import globalStyles from "../global";
import LaundryMan from "../components/aboutComponent/LaundryMan";
import Footer from "../components/HomeComponent/Footer";
import { getResponsiveSize } from "../utils/responsive";
import FranchiseTimeline from "../components/aboutComponent/FranchiseTimeline";
import AccordionUsage from "../components/servicesComponent/Accordin";
import { useTranslation } from "react-i18next";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import CountryBorder from "../components/globalCountries/countryhomepagescomponent/Countryborder";
const containerWidth = "1200px";
const About = () => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: globalStyles.colors.white,
      }}
    >
      <Box sx={styles.heroSection}>
        <Box sx={styles.container}>
          <Box
            component="img"
            src={`${imageBaseUrl}aboutUsNew.svg`}
            alt={t("countryServices.heroTitle.part1")}
            sx={{
              ...styles.heroImage,
              verticalAlign: "bottom",
              display: {
                xs: "none",
                sm: "none",
                md: "block",
              },
            }}
          />
          <Box
            sx={{
              px: { xs: 2, sm: 3, md: 0 },
              py: { xs: 2, sm: 3, md: 0 },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                ...styles.heroTitle,
                textAlign: { xs: "center", md: "left" },

                letterSpacing: "1%",
                color: globalStyles.colors.army_green,

                width: "100%",
                p: {
                  xs: "5%",
                  sm: "4%",
                  md: "0%",
                },
              }}
            >
              ALL YOU NEED TO <br />
              KNOW ABOUT <span style={styles.greenText}>UCLEAN</span>
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "100%", mt: 10, px: { xs: 2, md: 10 } }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",
            mt: 10,
            px: { xs: 2, sm: 0 },
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              fontFamily: globalStyles.fonts.primaryUAE,
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "30px",
                lg: "40px",
              },
              fontWeight: 400,
              textAlign: {
                xs: "center",
                sm: "center",
                md: "left",
              },
              mb: { xs: 2, sm: 2 },
              color: "#003A26",
              letterSpacing: "1%",
            }}
          >
            GLOBAL LEADERS IN LAUNDRY & DRYCLEANING SERVICES
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",

            mx: "auto",

            px: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              textAlign: { xs: "center", md: "left" },
              px: { xs: 2, md: 0 },
              width: "100%",
              maxWidth: "1200px",
            }}
          >
            <Typography
              sx={{
                color: "#666666",
                fontSize: { xs: "14px", md: "18px" },
                lineHeight: "auto",
                letterSpacing: "1%",
                fontFamily: "poppins",
                textAlign: "justify",
              }}
            >
              UClean is a global leader committed to making laundry and dry
              cleaning services affordable and effortless for everyone, with a
              vision to introduce an innovative and hygienic approach to
              cleanliness. From a single setup to a trusted international brand,
              UClean has been serving businesses and households for years. We
              believe cleanliness is more than just a service – it’s a
              responsibility that deserves care and attention.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          mt: 10,
          px: { xs: 2, sm: 0 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "flex-start",
          gap: 4,
        }}
      >
        {/* Left Side - Image and Franchise Count */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Box
            component="img"
            src={`${imageBaseUrl}worldAbout.svg`}
            alt="World Map"
            sx={{
              width: "100%",

              height: "auto",
              objectFit: "contain",
              mb: 2,
              p: 1,
              mx: { xs: "auto", md: "0" },

              display: "block",
            }}
          />
        </Box>

        {/* Right Side - Heading, Description and Stats */}
        <Box sx={{ flex: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              textAlign: { xs: "center", md: "left" },
              px: { xs: 2, md: 0 }, // optional mobile padding
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "18px", md: "24px" },
                fontWeight: 600,
                color: "#666666",
                mb: 2,
                fontFamily: "poppins",
                lineHeight: "100%",
                letterSpacing: "1%",
              }}
            >
              Your Partner in Modern Hygiene Solutions
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              px: { xs: 2, md: 0 }, // padding for mobile spacing
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                color: "#666666",
                lineHeight: "auto",
                letterSpacing: "1%",
                mb: 2,
                textAlign: "justify",
                fontFamily: "poppins",
                maxWidth: { xs: "100%", sm: "90%", md: "100%" }, // optional control
              }}
            >
              At UClean, we’re redefining how people experience laundry and
              cleaning. Our mission is to deliver the highest quality of laundry
              service at the convenience of your home. Powered by tech-driven
              systems, trained professionals, and modern cleaning techniques, we
              ensure that every garment is deeply cleaned with care. We strictly
              follow hygiene standards to guarantee both convenience and safety
              in every service.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              px: { xs: 2, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                color: "#666",
                lineHeight: 1.6,
                mb: 3,
                fontFamily: "poppins",
                textAlign: "justify",
                maxWidth: { xs: "100%", sm: "90%", md: "100%" },
              }}
            >
              We’re also committed to sustainable practices that reduce
              environmental impact while delivering top-quality results.
            </Typography>
          </Box>

          {/* Stats Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: { xs: 2, sm: 0 },
              justifyContent: {
                xs: "space-between",
                md: "flex-start", // align left on desktop
              },
              flexWrap: "nowrap",
              ml: {
                md: -10, // 👈 add left margin on desktop
              },
            }}
          >
            {/* Stat 1 */}
            <Box sx={{ width: "33.33%", textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    xs: "22px",
                    sm: "28px", // 👈 desktop
                  },
                  fontFamily: globalStyles.fonts.primary,
                  color: "#174C2E",
                }}
              >
                2M+
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    sm: "14px",
                  },
                  color: "#666666",
                  fontFamily: "poppins",
                  ml: 2,
                }}
              >
                Unique Users
              </Typography>
            </Box>
            <Box
              sx={{
                height: "94px",
                borderLeft: "1.71px solid #BBBBBB4D",
                ml: 10,
                display: { xs: "none", sm: "block" },
              }}
            />

            {/* Stat 2 */}
            <Box sx={{ width: "33.33%", textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    xs: "22px",
                    sm: "28px",
                    md: "31px",
                  },
                  fontFamily: globalStyles.fonts.primary,
                  color: "#174C2E",
                }}
              >
                200+
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    sm: "14px",
                  },
                  color: "#666666",
                  fontFamily: "poppins",
                  ml: 2,
                }}
              >
                Cities Nationwide
              </Typography>
            </Box>
            <Box
              sx={{
                height: "94px",
                borderLeft: "1.71px solid #BBBBBB4D",
                ml: 10,
                display: { xs: "none", sm: "block" },
              }}
            />
            {/* Stat 3 */}
            <Box sx={{ width: "33.33%", textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    xs: "22px",
                    sm: "28px",
                    md: "31px",
                  },
                  fontFamily: globalStyles.fonts.primary,
                  color: "#174C2E",
                }}
              >
                24/7
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    sm: "14px",
                  },
                  color: "#666666",
                  fontFamily: "poppins",
                  ml: 2,
                }}
              >
                Customer Support
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <FranchiseTimeline />

      <CountryBorder />
      <Box
        sx={{
          width: { xs: "90%", sm: "70%", md: "62%" },
          margin: "auto",
          paddingY: {
            xs: getResponsiveSize(3.2),
            sm: getResponsiveSize(3.6),
            md: getResponsiveSize(4),
          },
          mt: "3%",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            ...styles.text1,
            fontSize: { md: "40px", sm: "28px", xs: "24px" },

            fontFamily: globalStyles.fonts.primaryUAE,
            textTransform: "uppercase",
          }}
        >
          {t("about.teamTitle")}
        </Typography>
        <Box
          textAlign={"center"}
          sx={{
            height: {
              xs: getResponsiveSize(32),
              sm: getResponsiveSize(36),
              md: getResponsiveSize(40),
            },
          }}
        >
          <Typography
            // variant="regular_text_ur"
            sx={{
              fontSize: { sm: "18px", xs: "14px" },
              fontFamily: globalStyles.fonts.primary,
              color: "#666666",
              letterSpacing: "1%",
              lineHeight: "100%",
            }}
          >
            {t("about.teamDescription")}
          </Typography>
        </Box>
      </Box>
      <LaundryMan />
      <Box
        sx={{
          width: "100%",
          bgcolor: "#003A26",
          py: { xs: 6, sm: 8, md: 10 },
          px: 2,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "#ffffff",
            textAlign: "center",
            fontSize: { md: "45px", sm: "30px", xs: "26px" },
            fontWeight: 700,
            mb: 2,
            textTransform: "uppercase",
            fontFamily: globalStyles.fonts.primaryUAE,
          }}
        >
          OUR PROMISE TO YOU
        </Typography>

        <Typography
          sx={{
            color: "#d0d0d0",
            textAlign: "center",
            maxWidth: "1050px",
            mx: "auto",
            fontSize: { sm: "18px", xs: "14px" },
            mb: 6,
          }}
        >
          At UClean, we are dedicated to delivering exceptional cleaning
          services that prioritize both your clothes and the planet because you
          deserve cleaner clothes without compromise.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "11px",
            maxWidth: "1200px",
            mx: "auto",
          }}
        >
          {[
            {
              image: `${imageBaseUrl}promise1.png`,
              title: "Sustainable Practices",
              description:
                "We use eco-friendly detergents, water-saving technology, and energy-efficient processes to reduce environmental impact while keeping your clothes fresh and clean.",
            },
            {
              image: `${imageBaseUrl}promise2.png`,
              title: "Speed with Consistency",
              description:
                "Our tech-enabled systems and trained staff ensure fast turnaround times without cutting corners, so your garments are ready when you need them.",
            },
            {
              image: `${imageBaseUrl}promise3.png`,
              title: "Quality You Can Trust",
              description:
                "We believe in full transparency from pricing to process so you always know what to expect and receive consistent, top-quality care.",
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                padding: 3,
                textAlign: "center",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                flex: {
                  xs: "1 1 100%", // Full width on mobile
                  sm: "1 1 48%", // Two per row on tablet
                  md: "1 1 31%", // Three per row on desktop
                },
                //  minHeight: "364px", // Optional: keeps heights visually balanced
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={item.title}
                sx={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  mb: 2,
                  mx: "auto",
                }}
              />

              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { sm: "22px", xs: "15px" },
                  mb: 1,
                  color: "#004225",
                }}
              >
                {item.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: { sm: "18px", xs: "14px" },
                  color: "#444444",
                }}
              >
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <AccordionUsage />
      <News />
      <Footer />
    </Box>
  );
};

const styles = {
  text1: {
    color: globalStyles.colors.army_green,
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    marginTop: getResponsiveSize(8),
    marginBottom: getResponsiveSize(2),
    textAlign: "center",
  },
  heroSection: {
    bgcolor: "#F2F3F0",
    height: {
      xs: "280px",
      sm: "440px",
      md: "500px",
    },
    display: "flex",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    gap: "20px",

    justifyContent: "center",
    alignItems: "center",
    maxWidth: containerWidth,
    mx: "auto",
    height: "100%", // <-- Add this
  },
  heroImage: {
    width: {
      xs: 0,         // Hide on mobile
      sm: 0,         // Hide on small screens
      md: "50%",     // Show on md and up
    },
    height: {
      xs: 0,
      sm: 0,
      md: "100%",    // Fill banner height on md and up
    },
    maxHeight: "500px", // Match banner max height
    objectFit: "cover",
    display: {
      xs: "none",
      sm: "none",
      md: "block",
    },
    mt: 0,
  },
  heroTextBox: {
    minWidth: "400px",
    p: 2,
    py: {
      md: 2,
      xs: 8,
    },
    textAlign: {
      md: "left",
      xs: "center",
    },
  },
  heroTitle: {
    fontSize: {
      md: "55px",
      sm: "36px",
      xs: "30px",
    },
    color: globalStyles.colors.army_green,
    fontFamily: globalStyles.fonts.primaryUAE,
    letterSpacing: "1%",
  },
  greenText: {
    color: globalStyles.colors.uclean_green,
    display: "inline",
    fontFamily: globalStyles.fonts.primaryUAE,
    whiteSpace: "nowrap",
  },
};

export default About;
